import { Analytics, ANALYTICS_TYPES } from 'utils/analytics/analytics';
import { OPEN_CHAT, TYPE_USER_MESSAGE } from 'utils/analytics/plugins/helpCrunch';

export function showSupportChat() {
  const instance = Analytics.getInstance(ANALYTICS_TYPES.HELP_CRUNCH);
  if (instance) {
    instance(OPEN_CHAT);
  }
}

export const typeTextIntoSupportChat = (text) => {
  // @ts-ignore
  window.HelpCrunch(TYPE_USER_MESSAGE, text);
};

export function openChangePlanChat(text) {
  typeTextIntoSupportChat(text);
  showSupportChat();
}
